/* eslint-disable no-new */
import { isProd } from 'config/config';
import { sendInvoice, getOrderDetail } from 'helpers/api';
import { getUrlParamsByName, formatMoney, formatDate } from 'helpers/utils';
import { toggleModal } from './pd-modal';

import Vue from 'vue/dist/vue';

function init() {
    new Vue({
        el: '#order-details',
        data: {
            res: {},
            isLoading: true,
            orderNumber: '',
            showPrice: true,
            printNoShowCodes: ['1210', '1214', '1216'],
            emailFaxForm: {
                showEmailFaxModal: false,
                isEmail: null,
                deliveryAddress: '',
                errors: [],
                printFaxSuccess: null,
                failureMessage: '',
            },
        },
        mounted() {
            this.setValues();
        },
        computed: {
            didItemsLoad() {
                // hide/show item listing
                if (this.res.LineItems) {
                    return this.res.LineItems.length;
                }
            },
            showPrintButton() {
                // don't show button if ticket is in specific statuses
                if (this.printNoShowCodes.indexOf(this.res.TicketStatus) === -1) {
                    return true;
                }
            },
            isShippingUPS() {
                // check if UPS, then show formatted tracking link; if not, just show tracking number
                return (
                    this.res.TrackingInformation &&
                    this.res.TrackingInformation.substring(0, 2) == '1Z'
                );
            },
            backorderedItems() {
                // returns an array of all backordered items
                const backorderedItemsArray = [];

                if (this.res.LineItems) {
                    for (let i = 0; i < this.res.LineItems.length; i++) {
                        if (this.res.LineItems[i].QuantityBackordered) {
                            backorderedItemsArray.push(this.res.LineItems[i]);
                        }
                    }
                }
                return backorderedItemsArray;
            },
            allItemsBackordered() {
                if (this.backorderedItems && this.res.LineItems) {
                    const fullyBackorderedItems = [];

                    this.backorderedItems.forEach((item) => {
                        if (item.QuantityBackordered === item.QuantityOrdered) {
                            fullyBackorderedItems.push(item);
                        }
                    });

                    if (fullyBackorderedItems.length === this.res.LineItems.length) {
                        return true;
                    }
                }
                return false;
            },
            totalItemsCost() {
                // official total cost for fully invoiced order
                let totalCost = 0;
                if (this.res.LineItems) {
                    for (let i = 0; i < this.res.LineItems.length; i++) {
                        totalCost +=
                            this.res.LineItems[i].UnitPriceCost.replace(',', '') *
                            this.res.LineItems[i].QuantityShipped;
                    }
                }
                return totalCost;
            },
            totalItemsPendingCost() {
                // pending cost before order is invoiced
                let totalCost = 0;
                if (this.res.LineItems) {
                    for (let i = 0; i < this.res.LineItems.length; i++) {
                        totalCost +=
                            this.res.LineItems[i].UnitPriceCost.replace(',', '') *
                            this.res.LineItems[i].QuantityOrdered;
                    }
                }
                return totalCost;
            },
            totalSurchargeCost() {
                // get all surcharges applied to order
                let totalCost = 0;
                if (this.res.Surcharges) {
                    for (let i = 0; i < this.res.Surcharges.length; i++) {
                        totalCost += this.res.Surcharges[i].Amount;
                    }
                }
                return totalCost;
            },
        },
        filters: {
            formatDate(date) {
                return formatDate(date);
            },
            formatMoney(price) {
                return formatMoney(price);
            },
            formatTrackingURL(trackingNum) {
                return (
                    'http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=' + trackingNum
                );
            },
            formatPrintURL(orderNum) {
                return '/print/invoice?orderNumber=' + orderNum;
            },
            formatSalesOrderPrintURL(orderNum) {
                return '/print/SalesOrder?orderNumber=' + orderNum;
            },
            formatRelatedOrderURL(orderNum) {
                return isProd
                    ? `/portal/order-details?orderNumber=${orderNum}`
                    : `/order-details.html?orderNumber=${orderNum}`;
            },
        },
        methods: {
            async setValues() {
                // get orderNumber
                this.orderNumber = getUrlParamsByName('orderNumber');

                const shippingRes = await getOrderDetail(this.orderNumber);
                this.res = shippingRes.data;

                this.isLoading = false;
            },
            showEmailFaxModal() {
                toggleModal(null, true);
            },
            hideEmailFaxModal() {
                toggleModal(null, false);

                // reset values
                this.emailFaxForm.isEmail = null;
                this.emailFaxForm.deliveryAddress = '';
                this.emailFaxForm.errors = [];
                (this.emailFaxForm.printFaxSuccess = null), (this.emailFaxForm.failureMessage = '');
            },
            handleEmailFaxSubmit() {
                // reset, check for errors
                this.emailFaxForm.errors = [];

                if (this.emailFaxForm.isEmail === null) {
                    this.emailFaxForm.errors.push('Delivery type required.');
                }
                if (!this.emailFaxForm.deliveryAddress.length) {
                    this.emailFaxForm.errors.push('Email or fax number required.');
                }

                // if no errors, submit to API
                if (!this.emailFaxForm.errors.length) {
                    sendInvoice({
                        invoiceNumber: this.orderNumber,
                        isEmail: this.emailFaxForm.isEmail,
                        emailFax: this.emailFaxForm.deliveryAddress,
                    }).then((result) => {
                        this.emailFaxForm.printFaxSuccess = result.Successful;
                        this.emailFaxForm.failureMessage = result.ErrorText;
                    });
                }
            },
        },
    });
}

export default init;
